import React, { memo } from 'react';

// Use dynamic import with try/catch to handle missing info.json
let info = {
    name: 'referral-management-application',
    version: 'development',
    status: 'UP',
    commit: 'local'
};

// Try to load the actual info.json if it exists
try {
    // Using require instead of import to handle the case when the file doesn't exist
    info = require('./info.json');
} catch (e) {
    console.warn('info.json not found, using default values');
}

export const Info = memo(function Info () {
    const infoStr = JSON.stringify(info, null, 2);
    return (
        <pre>
            { infoStr }
        </pre>
    );
});
